/**
 * frontmatter.js — lee el encabezado de una lección (Markdown + frontmatter YAML) sin sumar una librería de YAML.
 *
 * Entiende solo el subconjunto que usan las lecciones:
 *   - clave: valor            (texto, "texto entre comillas", número, true/false, [a, b])
 *   - clave:                  seguida de una lista de objetos   «  - n: 1 / titulo: "…"» (pasos, casos)
 *   - comentarios con « # » al final de la línea (fuera de comillas)
 * Devuelve { data, body }. Si el archivo no tiene frontmatter, data = {}.
 */

/** Corta un comentario « # …» al final del valor, sin tocar los # que están dentro de comillas. */
function sinComentario(s) {
  let comillas = false;
  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    if (c === "\\" && comillas) { i++; continue; }
    if (c === '"') comillas = !comillas;
    else if (c === "#" && !comillas && (i === 0 || /\s/.test(s[i - 1]))) return s.slice(0, i);
  }
  return s;
}

function valor(crudo) {
  const s = String(crudo ?? "").trim();
  if (s === "") return "";
  if (s.startsWith('"')) {
    try { return JSON.parse(s); } catch { return s.replace(/^"|"$/g, ""); }
  }
  if (s.startsWith("'")) return s.replace(/^'|'$/g, "");
  if (s.startsWith("[") && s.endsWith("]")) {
    const dentro = s.slice(1, -1).trim();
    return dentro ? dentro.split(",").map(x => valor(x)) : [];
  }
  if (s === "true") return true;
  if (s === "false") return false;
  if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
  return s;
}

export function parsear(texto) {
  const t = String(texto || "").replace(/\r\n/g, "\n");
  const m = t.match(/^---\n([\s\S]*?)\n---\n?([\s\S]*)$/);
  if (!m) return { data: {}, body: t.trim() };

  const data = {};
  let lista = null;   // clave de la lista que se está leyendo
  let item = null;    // objeto actual dentro de esa lista

  for (const linea of m[1].split("\n")) {
    if (!linea.trim() || /^\s*#/.test(linea)) continue;

    const raiz = linea.match(/^([A-Za-z_]\w*):(?:\s+(.*))?$/);
    if (raiz) {
      const v = sinComentario(raiz[2] ?? "");
      if (v.trim() === "") { data[raiz[1]] = []; lista = raiz[1]; item = null; }
      else { data[raiz[1]] = valor(v); lista = null; item = null; }
      continue;
    }
    const nuevo = linea.match(/^\s+-\s+([A-Za-z_]\w*):(?:\s+(.*))?$/);
    if (nuevo && lista) {
      item = {};
      data[lista].push(item);
      item[nuevo[1]] = valor(sinComentario(nuevo[2] ?? ""));
      continue;
    }
    const campo = linea.match(/^\s+([A-Za-z_]\w*):(?:\s+(.*))?$/);
    if (campo && item) { item[campo[1]] = valor(sinComentario(campo[2] ?? "")); continue; }

    const escalar = linea.match(/^\s+-\s+(.*)$/);
    if (escalar && lista) data[lista].push(valor(sinComentario(escalar[1])));
  }
  return { data, body: m[2].trim() };
}
